import { useEffect, useState } from "react";

/** Search as you type waits this long after the last keystroke before asking the server. */
export const SEARCH_DEBOUNCE_MS = 300;

/**
 * `value`, once it has stopped changing for `ms`. Every keystroke otherwise
 * becomes a request, and at ~250 ms to the database the answers arrive out of
 * order.
 */
export function useDebounced<T>(value: T, ms = SEARCH_DEBOUNCE_MS): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return settled;
}
